import React from 'react';
import FlatList from '../../../Base/Components/FlatList';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import PatientsGroupsHistoryListItem from './PatientsGroupsHistoryListItem';

interface Props {
	flatData: any[];
	onLoadMore: () => void;
	onRefresh: () => void;
	isLoading: boolean;
	hasMoreData: boolean;
}

const WRAPPER_ID = 'patientsGroupHistoryWrapper';

const PatientsGroupsHistoryList: React.FC<Props> = ({
	onRefresh,
	isLoading,
	hasMoreData,
	onLoadMore,
	flatData,
}) => {
	return (
		<ScrollContainer wrapperId={WRAPPER_ID}>
			<FlatList
				onRefresh={onRefresh}
				onLoadMore={onLoadMore}
				data={flatData}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				scrollableTargetId={WRAPPER_ID}
				itemKey={'id'}
				renderItem={item => <PatientsGroupsHistoryListItem item={item} />}
			/>
		</ScrollContainer>
	);
};

export default PatientsGroupsHistoryList;
